import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import { createReaction } from '../../actions/reactionActions'
import { getPostInfo, clearPostInfo, resetInfo, editPost, saveContent, deletePost, getPostZoneInfo } from '../../actions/userActions'

import PostView from '../../containers/Post/Post/Post'

const Post = ({ history, match, deletePost, clearPostInfo, getPostInfo, getPostZoneInfo, isLoadingPost, userPosts }) => {
  const dispatch = useDispatch();
  const [friendsTag, setFriendsTag] = useState({})
  const [description, setDescription] = useState('')
  const descriptionLinkRef = useRef()
  if (match.params.zoneId) {
    // alert('post zone')
  }




  // console.log();
  const data = userPosts[0] ? userPosts[0].typePost === 4 ? userPosts[0].postIdContent : userPosts[0] : {}
  const dataShare = userPosts[0] && userPosts[0].typePost === 4 ? userPosts[0] : null
  // useEffect(() => {

  //   return () => {
  //     renderPost()
  //   }
  // }, [])
  //  console.log();
  //const dataShare = userPosts[0] ? userPosts[0].typePost === 4 ? userPosts[0] : false : false
  // const isMark = userPosts[0] && userPosts[0].trademarkID ? userPosts[0].trademarkID._id === localStorage().getItem('idUser') : false
  // const dataShareUser = userPosts[0] && userPosts[0].typePost === 4 && userPosts[0].postIdContent && (userPosts[0].postIdContent.userId ? userPosts[0].postIdContent.userId : userPosts[0].postIdContent.professionalProfileID ? userPosts[0].postIdContent.professionalProfileID : userPosts[0].postIdContent.trademarkID ? userPosts[0].postIdContent.trademarkID : {})
  //const dataUser = userPosts[0] && (userPosts[0].userId ? userPosts[0].userId : userPosts[0].professionalProfileID ? userPosts[0].professionalProfileID : userPosts[0].trademarkID ? userPosts[0].trademarkID : {})

  const dataUser = data?.userId ? {
    _id: data.userId._id,
    name: data.userId.name,
    lastname: data.userId.lastname,
    picture: data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin
  } :
    data?.franchiseID ?
      {
        _id: data.franchiseID._id,
        name: data?.franchiseID.socialReason,
        lastname: "",
        picture: data.franchiseID && data.franchiseID.picture && data.franchiseID.picture.url && data.franchiseID.picture.url.origin
      } :
      data?.franchiseId ?
      {
        _id: data.franchiseId._id,
        name: data?.franchiseId.socialReason,
        lastname: "",
        picture: data.franchiseId && data.franchiseId.picture && data.franchiseId.picture.url && data.franchiseId.picture.url.origin
      } :
      data?.representativeID ?
        {
          _id: data?.representativeID._id,
          name: data?.representativeID.userID.name,
          lastname: data?.representativeID.userID.lastname,
          picture: data.representativeID.userID && data.representativeID.userID.picture && data.representativeID.userID.picture.url && data.representativeID.userID.picture.url.origin
        } :
        data?.representativeId ?
        {
          _id: data?.representativeId._id,
          name: data?.representativeId.userID.name,
          lastname: data?.representativeId.userID.lastname,
          picture: data.representativeId.userID && data.representativeId.userID.picture && data.representativeId.userID.picture.url && data.representativeId.userID.picture.url.origin
        } :
        data?.warehouseId ?
          {
            _id: data?.warehouseId._id,
            name: data?.warehouseId.name,
            lastname: "",
            picture: data.warehouseId.profileId && data.warehouseId.profileId.picture && data.warehouseId.profileId.picture.url && data.warehouseId.profileId.picture.url.origin
          } : {
            _id: "",
            name: "",
            lastname: "",
            lastname: "",
            picture: "",
          }



  const dataUserShared = !dataShare ? null : dataShare?.userId ? {
    _id: dataShare.userId._id,
    name: dataShare.userId.name,
    lastname: dataShare.userId.lastname,
    picture: dataShare.userId && dataShare.userId.picture && dataShare.userId.picture.url && dataShare.userId.picture.url.origin
  } :
    dataShare?.franchiseID ?
      {
        _id: dataShare.franchiseID._id,
        name: dataShare?.franchiseID.socialReason,
        lastname: "",
        picture: dataShare.franchiseID && dataShare.franchiseID.picture && dataShare.franchiseID.picture.url && dataShare.franchiseID.picture.url.origin
      } :
      dataShare?.representativeID ?
        {
          _id: dataShare?.representativeID.userID._id,
          name: dataShare?.representativeID.userID.name,
          lastname: dataShare?.representativeID.userID.lastname,
          picture: dataShare.representativeID.userID && dataShare.representativeID.userID.picture && dataShare.representativeID.userID.picture.url && dataShare.representativeID.userID.picture.url.origin
        } :
        {
          _id: "1234",
          name: "reNAME",
          lastname: "reLastName",
          lastname: "",
          picture: "",
        }


  useEffect(() => {
    if (match.params.zonePostID) {
      getPostZoneInfo(match.params.zonePostID, history.location.pathname.includes('Professional'))
    } else {
      getPostInfo(match.params.postID, history.location.pathname.includes('Professional'))
    }

    return () => {
      clearPostInfo()
    }
  }, [match.params.postID])



  const linkify = (text) => {
    if (text) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
      descriptionLinkRef.current.innerHTML = text.replace(urlRegex, (url) => { return '<a href="' + url + '"  target="_blank">' + url + '</a>'; })
    }
  }

  console.log()
  useEffect(() => {
    if (userPosts[0]) {
      if (userPosts[0].multimedia?.type.includes('video/hls')){
        clearPostInfo()
        history.push("/Stream/"+userPosts[0]._id)
      }
      var data = userPosts[0] ? userPosts[0] : {}
      setDescription(data.description)
      if (userPosts[0].typePost === 3)
        linkify(data.description)
  
      data.taggedUsers && data.taggedUsers.map(tagFriend => {
        setFriendsTag(prevState => { return { ...prevState, [tagFriend._id]: tagFriend } })
      })
    }
    return () => {
      var data = userPosts[0] ? userPosts[0] : {}
      if (data.multimedia?.type.includes('video/hls')) {
        //    renderPost({})
      }
    }
  }, [userPosts])



  console.log()

  return (
    <PostView
      contentEnable={!isLoadingPost && userPosts[0] && ((userPosts[0].userId ||  userPosts[0].franchiseId || userPosts[0].franchiseID || userPosts[0].representativeId || userPosts[0].representativeID || userPosts[0].warehouseId) && userPosts[0].isEnabled) ? true : false}
      createReactionBubble={() => { dispatch(createReaction(data?._id, 'RCT01', 0, false, false, 'post', false)) }}
      createReactionRecycle={() => { dispatch(createReaction(data?._id, 'RCT02', 0, false, false, 'post', false)) }}
      saveContent={() => { dispatch(saveContent({ contentID: data?._id }, history)) }}
      descriptionLinkRef={descriptionLinkRef}
      isLoadingPost={isLoadingPost}
      dataUser={dataUser}
      data={data}
      dataUserShared={dataUserShared}

      deletePost={deletePost}
    />
  )


}


const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
  return {
    isLoadingPost: state.userInfo.isLoadingPostInfo,
    isLoading: state.userInfo.isLoadingAddCountCommentPostProfile, // y lo que retorna map, connect lo envia a Page como Props 
    success: state.register.success,
    userPosts: state.userInfo.postInfo,
    isLoadingLikeProfile: state.userInfo.isLoadingLikePost,
    isLoadingLikeHome: state.home.isLoadingLikePostHome
  }
}


export default connect(mapStateToProps, { getPostInfo, clearPostInfo, editPost, deletePost, resetInfo, getPostZoneInfo })(Post)
